import { useEffect, useState } from 'react';

import { useAppStore } from 'src/hooks/useAppStore';
import {
  getDisplayPlansData,
  getDisplayPlansMetaData
} from 'src/services/apiRequests/SubscriptionService';
import { Data } from 'src/services/responseTypes/displayPlansResponse';
import SimpleStore from 'src/store/SimpleStore';
import { LapserAdvanceRenewalNudge } from 'src/types/lapser';
import { HTTP_URL_PARAMS } from 'src/utils/constants/HttpMethodsConstants';
import { HamburgerMenuLinks } from 'src/utils/constants/RouterConstants';
import { buyPlan } from 'src/utils/SubscriptionHelper/SubscriptionHelper';

import {
  animatedBorder,
  animatedSlide1,
  Container,
  offerDiv,
  slide1,
  slide2,
  slide3
} from './styles';

const SlideShow = ({ discountAmount }: { discountAmount: number }) => {
  const { translations } = useAppStore();
  const OFF_PERCENT = `${discountAmount} %`;
  const { LAPSER } = translations?.common ?? {};
  const {
    renew_plan_header_cta: RENEW_TEXT,
    lapser_cta_discount: DISCOUNT,
    lapser_cta_limited_time: LIMITED_TIME,
    lapser_cta_off: OFF
  } = LAPSER ?? {};

  return (
    <>
      <div css={[slide1, animatedSlide1]}>
        <span>{RENEW_TEXT}</span>
      </div>
      <div css={slide2}>
        {OFF_PERCENT} <span>{OFF}</span>
      </div>
      <div css={slide3}>
        <div css={offerDiv}>
          <span>{OFF_PERCENT}</span>
          <div>
            <span>{LIMITED_TIME}</span>
            <span>{DISCOUNT}</span>
          </div>
        </div>
      </div>
    </>
  );
};

const AnimatedButton = ({
  lapserDetails
}: {
  lapserDetails: LapserAdvanceRenewalNudge;
}) => {
  const { translations, plansMetaData, setPlansMetaData } = useAppStore();
  const [plansData, setPlansData] = useState<Data | null>(null);

  const country = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);

  const { LAPSER } = translations?.common ?? {};

  const { renew_plan_header_cta: RENEW_TEXT } = LAPSER ?? {};

  const { lapserAdvanceRenewal } = lapserDetails ?? {};
  const { actionData, discount } = lapserAdvanceRenewal ?? {};
  const { planId, id: nudgeId, targetPage = '', planPrice } = actionData ?? {};
  const { amount: discountAmount = 0, planDiscountedPrice } = discount ?? {};

  const getDisplayPlans = async () => {
    const displayPlans = await getDisplayPlansData();
    if (displayPlans) {
      setPlansData(displayPlans);
    }
  };
  const getDisplayPlansMeta = async () => {
    const displayPlans = await getDisplayPlansMetaData();
    if (displayPlans) {
      setPlansMetaData(displayPlans);
    }
  };

  useEffect(() => {
    if (!plansData) {
      getDisplayPlans();
    }
    if (!plansMetaData) {
      getDisplayPlansMeta();
    }
  }, []);

  const clickHandler = () => {
    if (!plansData || !plansMetaData) {
      window.location.href = HamburgerMenuLinks.BUY_PLAN;
      return;
    }
    if (targetPage.toUpperCase() !== 'PAYMENT' && planId) {
      buyPlan(
        plansData,
        plansMetaData,
        null,
        planId,
        {},
        '',
        country,
        null,
        false,
        {
          nudgeId,
          price: planDiscountedPrice ?? planPrice,
          sell_price: planPrice
        }
      );
      window.location.href = '/myaccount/payment';
    } else {
      window.location.href = HamburgerMenuLinks.BUY_PLAN;
    }
  };

  return (
    <Container
      css={[discountAmount > 0 && animatedBorder]}
      onClick={clickHandler}>
      {discountAmount > 0 ? (
        <SlideShow discountAmount={discountAmount} />
      ) : (
        <div css={slide1}>
          <span>{RENEW_TEXT}</span>
        </div>
      )}
    </Container>
  );
};
export default AnimatedButton;
